<ul class="meta-list meta-list--bullets">
  <li *ngFor="let link of links" data-dgat="sectionHead-4ef">
    <a
      *ngIf="link.url"
      class="carousel__link link epsilon no-wrap"
      [href]="link.url"
      [textContent]="link.label"
      (click)="link.onClick($event)"
      [attr.role]="link.role"
      [attr.tabindex]="!link.url ? 0 : undefined"
      data-dgat="linkRow-cf7"
    ></a>
    <a
      *ngIf="link.routerLink"
      class="carousel__link link epsilon no-wrap"
      [routerLink]="
        link.routerParams
          ? [link.routerLink, link.routerParams]
          : link.routerLink
      "
      [queryParams]="link.queryParams"
      [textContent]="link.label"
      [attr.role]="link.role"
      [attr.tabindex]="!link.routerLink ? 0 : undefined"
      data-dgat="linkRow-cf7"
    ></a>
    <a
      *ngIf="link.onClick && !link.url"
      class="carousel__link link epsilon no-wrap"
      [textContent]="link.label"
      (click)="link.onClick($event)"
      [attr.role]="link.role"
      [attr.tabindex]="!link.routerLink ? 0 : undefined"
      data-dgat="linkRow-cf7"
    ></a>
  </li>
</ul>
